<template>
  <div id="app">
    <nav class="navbar" role="navigation" aria-label="主导航">
      <div class="container">
        <div class="flex">
          <div class="logo" aria-label="1900软件">
            <img src="@/assets/ic_launcher_round.png" alt="1900软件" />
            <span>1900软件</span>
          </div>
          <div class="nav-menu" :class="{ active: isMenuOpen }" role="menubar">
            <a href="#1900" @click="closeMenu" role="menuitem" tabindex="0"
              >1900节拍器</a
            >

            <a
              href="#mini-products"
              @click="closeMenu"
              role="menuitem"
              tabindex="0"
              >1900媒体助手 Mini</a
            >
            <a href="#xqhelper" @click="closeMenu" role="menuitem" tabindex="0"
              >1900媒体助手软件 客户端</a
            >
            <!-- <a href="#how-it-works" @click="closeMenu">工作原理</a>
            <a href="#features" @click="closeMenu">功能特色</a>
            <a href="#download" @click="closeMenu">立即下载</a>
            <a href="#faq" @click="closeMenu">常见问题</a> -->
            <!-- <a href="#support" @click="closeMenu">使用帮助</a> -->
          </div>
          <div
            class="hamburger"
            @click="toggleMenu"
            role="button"
            aria-label="切换导航菜单"
            tabindex="0"
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </nav>

    <!-- <div class="vbg">
      <video class="blurred-background" autoplay muted loop>
        <source src="@/assets/bg.mp4" type="video/mp4" />
      </video>

      <div class="hero">
        <div class="container">
          <h1 class="hero-title">1900媒体助手桌面端</h1>
          <p class="subtitle">专业下载网络媒体工具 - 支持微信小程序、浏览器及各类客户端</p>
          <button class="cta-button primary" @click="downfile">立即下载</button>
          <p class="supported-platforms">支持 Windows 7 及以上系统</p>
        </div>
      </div>
    </div> -->
    <main role="main">
      <section
        id="1900"
        class="metronome-app-section"
        itemscope
        itemtype="http://schema.org/SoftwareApplication"
      >
        <div class="container">
          <h2 class="section-title" itemprop="name">1900节拍器APP</h2>
          <div class="section-subtitle" itemprop="description">
            专业的节拍器应用，为音乐爱好者打造
          </div>
          <div class="section-subtitle warning">1900 只为你发声</div>

          <!-- 应用截图展示 -->
          <div class="metronome-screenshots">
            <div class="carousel-container">
              <!-- 土泡泡效果 -->
              <div class="bubbles">
                <div
                  class="bubble-item"
                  v-for="index in 15"
                  :key="index"
                  :style="{ '--i': index }"
                ></div>
              </div>

              <div class="carousel" ref="carousel">
                <div class="carousel-slide">
                  <img
                    src="@/assets/1900me/Screenshot_20251218_103301.png"
                    alt="1900节拍器截图1"
                    class="carousel-image"
                  />
                </div>
                <div class="carousel-slide">
                  <img
                    src="@/assets/1900me/Screenshot_20251218_103403.png"
                    alt="1900节拍器截图2"
                    class="carousel-image"
                  />
                </div>
                <div class="carousel-slide">
                  <img
                    src="@/assets/1900me/Screenshot_20251218_103437.png"
                    alt="1900节拍器截图3"
                    class="carousel-image"
                  />
                </div>
                <div class="carousel-slide">
                  <img
                    src="@/assets/1900me/Screenshot_20251218_103507.png"
                    alt="1900节拍器截图4"
                    class="carousel-image"
                  />
                </div>
                <div class="carousel-slide">
                  <img
                    src="@/assets/1900me/Screenshot_20251218_103526.png"
                    alt="1900节拍器截图5"
                    class="carousel-image"
                  />
                </div>
                <div class="carousel-slide">
                  <img
                    src="@/assets/1900me/Screenshot_20251218_103538.png"
                    alt="1900节拍器截图6"
                    class="carousel-image"
                  />
                </div>
                <div class="carousel-slide">
                  <img
                    src="@/assets/1900me/Screenshot_20251218_103549.png"
                    alt="1900节拍器截图7"
                    class="carousel-image"
                  />
                </div>
              </div>
              <button class="carousel-btn prev" @click="prevSlide">&lt;</button>
              <button class="carousel-btn next" @click="nextSlide">&gt;</button>
              <div class="carousel-indicators">
                <span
                  v-for="index in 7"
                  :key="index"
                  class="indicator"
                  :class="{ active: currentSlide === index - 1 }"
                  @click="goToSlide(index - 1)"
                ></span>
              </div>
            </div>
          </div>

          <!-- 应用特点 -->
          <div class="metronome-features">
            <h3 class="features-title">应用特点</h3>
            <div class="features-list">
              <div class="feature-item">
                <div class="feature-icon">🎵</div>
                <div class="feature-content">
                  <h4>精准节拍</h4>
                  <p>高精度节拍生成，确保每一拍都准确无误</p>
                </div>
              </div>
              <div class="feature-item">
                <div class="feature-icon">🎹</div>
                <div class="feature-content">
                  <h4>丰富音效</h4>
                  <p>多种乐器音色选择，满足不同音乐风格需求</p>
                </div>
              </div>
              <div class="feature-item">
                <div class="feature-icon">🎤</div>
                <div class="feature-content">
                  <h4>人声喊拍</h4>
                  <p>清晰的人声喊拍功能，帮助你更好地把握节奏</p>
                </div>
              </div>
              <div class="feature-item">
                <div class="feature-icon">🎚️</div>
                <div class="feature-content">
                  <h4>节拍自定义</h4>
                  <p>自由调整节拍速度、拍号，适应各种音乐练习</p>
                </div>
              </div>
            </div>
          </div>

          <!-- 下载按钮 -->
          <div class="metronome-download">
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
            <button class="cta-button primary" @click="downloadMetronome">
              立即下载
            </button>
            <p class="supported-platforms">支持 Android 系统</p>
          </div>
        </div>
      </section>
      <section
        id="mini-products"
        class="mini-products-section"
        itemscope
        itemtype="http://schema.org/SoftwareApplication"
      >
        <div class="container">
          <h2 class="section-title" itemprop="name">1900媒体助手Mini</h2>
          <div class="section-subtitle" itemprop="description">
            轻量级版本，专为不同平台优化，随时随地享受1900媒体助手的强大功能
          </div>
          <div class="section-subtitle warning">
            不支持微信小程序等其他客户端软件的数据获取
          </div>

          <div class="mini-products-grid">
            <div class="mini-product-card">
              <div class="product-icon">
                <img src="@/assets/android-logo.svg" alt="Android" />
              </div>
              <h3>1900媒体助手 Mini for Android</h3>
              <p>Android兼容主流安卓设备</p>
              <div class="product-features">
                <span class="feature-tag Android">视频预览</span>
                <span class="feature-tag Android">图片预览</span>
              </div>
              <button
                class="mini-download-btn Android"
                @click="downloadAndroid"
              >
                立即下载
              </button>
            </div>

            <!-- <div class="mini-product-card">
              <div class="product-icon">
                <img src="@/assets/windows-logo.svg" alt="Windows" />
              </div>
              <h3>1900媒体助手 Mini for Windows</h3>
              <p>轻量级Windows版本，占用资源更少，运行更流畅</p>
              <div class="product-features ">
                <span class="feature-tag windows">轻量快速</span>
               
                <span class="feature-tag windows">操作简单</span>
              </div>
              <button class="mini-download-btn windows" @click="downloadWindows">立即下载</button>
            </div> -->
          </div>
        </div>
      </section>
      <section
        class="mini-products-section"
        id="xqhelper"
        itemscope
        itemtype="http://schema.org/SoftwareApplication"
      >
        <div class="container">
          <h2 class="section-title" itemprop="name">1900媒体助手软件客户端</h2>
          <div class="section-subtitle" itemprop="description">
            1900媒体助手户端 专业媒体资源下载工具
          </div>
        </div>
      </section>
      <div class="vbg">
        <video class="blurred-background" autoplay muted loop>
          <source src="@/assets/bg.mp4" type="video/mp4" />
        </video>

        <div class="hero">
          <div class="container">
            <h1 class="hero-title">1900媒体助手桌面端</h1>
            <p class="subtitle">
              专业下载网络媒体工具 - 支持微信小程序、浏览器及各类客户端
            </p>
            <button class="cta-button secondary" @click="downfile">
              Windows 下载
            </button>
            <button class="cta-button secondary" onclick="window.location.href='http://app.iawhy.com/exe/rqhelper1900.dmg'">
              Mac 下载
            </button>
            <p class="supported-platforms">支持 Windows 7 及以上系统 / macOS 10.13 及以上</p>
          </div>
        </div>
      </div>

      <section id="features" class="features-section">
        <div class="container">
          <h2 class="section-title">功能特色</h2>
          <div class="features-grid">
            <div class="feature-card">
              <div class="feature-content">
                <h3 id="resource-download">多种资源下载</h3>
                <ul>
                  <li>微信小程序资源获取</li>
                  <li>抖音、B站等短视频下载</li>
                  <li>各类图片资源收集</li>
                  <li>文档及其他格式文件</li>
                </ul>
                <div id="wechat-miniprogram"></div>
                <div id="douyin"></div>
                <div id="kuaishou"></div>
                <div id="weibo-zhihu"></div>
              </div>
            </div>
            <video autoplay muted loop class="vbg2">
              <source src="@/assets/bg2.mp4" type="video/mp4" />
            </video>
          </div>

          <div class="features-grid reverse">
            <div class="feature-card">
              <div class="feature-content">
                <h3 id="security">安全可靠</h3>
                <ul>
                  <li>采用本地代理技术，数据不外泄</li>
                  <li>无需上传任何个人隐私信息</li>
                  <li>绿色无毒，通过多重安全检测</li>
                  <li>完全离线操作，保护用户隐私</li>
                </ul>
                <div id="high-quality-download"></div>
                <div id="batch-download"></div>
              </div>
            </div>
            <img src="@/assets/bg4.png" alt="安全演示" class="vbg2" />
          </div>
        </div>
      </section>

      <section id="how-it-works" class="how-it-works-section">
        <div class="container">
          <h2 class="section-title">工作原理</h2>
          <div class="steps">
            <div class="step">
              <div class="step-icon">
                <svg
                  viewBox="0 0 24 24"
                  width="60"
                  height="60"
                  fill="none"
                  stroke="#ff0000"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2Z"
                  />
                  <path d="M10 8H14V22H10V8Z" />
                </svg>
              </div>
              <h3>启动代理</h3>
              <p>运行1900媒体助手，自动设置本地代理服务器</p>
            </div>
            <div class="step">
              <div class="step-icon">
                <svg
                  viewBox="0 0 24 24"
                  width="60"
                  height="60"
                  fill="none"
                  stroke="#00aa00"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                  />
                  <path d="M12 8V12L15 15" />
                </svg>
              </div>
              <h3>浏览内容</h3>
              <p>正常使用微信小程序、浏览器或其他客户端应用</p>
            </div>
            <div class="step">
              <div class="step-icon">
                <svg
                  viewBox="0 0 24 24"
                  width="60"
                  height="60"
                  fill="none"
                  stroke="#00aaff"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M21 21L16.65 16.65" />
                  <circle cx="11" cy="11" r="8" />
                  <path d="M21 12H18" />
                  <path d="M12 3V6" />
                  <path d="M3 12H6" />
                  <path d="M12 18V21" />
                </svg>
              </div>
              <h3>智能识别</h3>
              <p>自动捕获网络请求中的图片、视频等媒体资源</p>
            </div>
            <div class="step">
              <div class="step-icon">
                <svg
                  viewBox="0 0 24 24"
                  width="60"
                  height="60"
                  fill="none"
                  stroke="#ffaa00"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2Z"
                  />
                  <path
                    d="M20 14V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V14"
                  />
                  <path d="M12 12L16 16" />
                  <path d="M12 12L8 16" />
                  <path d="M12 12V18" />
                </svg>
              </div>
              <h3>一键下载</h3>
              <p>在助手界面中选择所需资源，点击即可下载</p>
            </div>
          </div>
        </div>
      </section>

      <section id="download" class="download-section">
        <div class="container">
          <h2 class="section-title white">立即体验</h2>
          <p class="download-description">免费下载1900媒体助手，解锁无限可能</p>
          <div class="download-options">
            <div class="download-card">
              <img src="@/assets/windows-logo.svg" alt="Windows" />
              <h3>Windows 版</h3>
              <p>支持 Windows 7 及以上系统</p>
              <button class="download-btn" @click="downfile">
                下载 (.exe)
              </button>
            </div>

            <div class="download-card">
             
              <img src="@/assets/mac-logo.svg" alt="Mac" />
              <h3>macOS 版</h3>
              <p>支持 macOS 10.13 及以上版本</p>
              <button class="download-btn" @click="downloadMac" >下载(.dmg)</button>
            </div>
          </div>
        </div>
      </section>

      <section id="faq" class="faq-section">
        <div class="container">
          <h2 class="section-title">常见问题</h2>

          <div class="faq-container">
            <div class="faq-item">
              <div class="faq-question">
                <h3>“1900媒体助手”是否安全？</h3>
                <span class="faq-toggle">+</span>
              </div>
              <div class="faq-answer">
                <p>
                  非常安全。“1900媒体助手”采用本地代理技术，所有数据都在本地处理，不会上传到任何服务器。软件已通过多家安全软件检测，无病毒、无木马。
                </p>
              </div>
            </div>
            <div class="faq-item">
              <div class="faq-question">
                <h3>“1900媒体助手”是否收费？</h3>
                <span class="faq-toggle">+</span>
              </div>
              <div class="faq-answer">
                <p>目前是完全免费的软件，不收取任何费用。</p>
              </div>
            </div>
            <div class="faq-item">
              <div class="faq-question">
                <h3>“1900媒体助手”如何添加功能？</h3>
                <span class="faq-toggle">+</span>
              </div>
              <div class="faq-answer">
                <p>
                  欢迎您来定制我们的产品，在不考虑大改的情况下，我们这里需要收取一定的开发费用，敬请谅解！
                </p>
              </div>
            </div>
            <div class="faq-item">
              <div class="faq-question">
                <h3>支持哪些平台的资源下载？</h3>
                <span class="faq-toggle">+</span>
              </div>
              <div class="faq-answer">
                <p>
                  支持微信小程序、抖音、B站、微博、知乎等几乎所有主流平台的图片和视频资源下载。只要是通过网络传输的媒体资源，都可以被识别和下载。
                </p>
              </div>
            </div>

            <div class="faq-item">
              <div class="faq-question">
                <h3>是否有使用次数等限制？</h3>
                <span class="faq-toggle">+</span>
              </div>
              <div class="faq-answer">
                <p>
                  没有限制。VIP用户终身免费更新、在线一对一服务，无后顾之忧。
                </p>
              </div>
            </div>

            <div class="faq-item">
              <div class="faq-question">
                <h3>下载的文件保存在哪里？</h3>
                <span class="faq-toggle">+</span>
              </div>
              <div class="faq-answer">
                <p>
                  默认保存在"我的文档/"文件夹中。您可以在软件设置中自定义保存路径。
                </p>
              </div>
            </div>
          </div>
          <div class="text-center" style="margin-top: 30px">
            <button id="load-more-faq" class="cta-button primary">
              展开更多问题
            </button>
          </div>
        </div>
      </section>
    </main>

    <footer id="support" class="footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-section">
            <h4>产品特色</h4>
            <a href="#resource-download">多种资源支持</a>
            <a href="#security">本地代理技术</a>
            <a href="#high-quality-download">高清无损下载</a>
            <a href="#batch-download">批量下载功能</a>
          </div>

          <div class="footer-section">
            <h4>支持平台</h4>
            <a href="#wechat-miniprogram">微信小程序</a>
            <a href="#douyin">抖音短视频</a>
            <a href="#kuaishou">B站短视频</a>
            <a href="#weibo-zhihu">微博/知乎等</a>
          </div>
          <div class="footer-section secondary">
            <h4>使用指南</h4>
            <a href="https://v.douyin.com/gbQCUj8gMY8/">🌟视频教学</a>
            <a
              href="https://gitcode.com/SUI517/xtRqHelper/blob/master/readme/license.md"
              >📚软件使用协议</a
            >
            <a
              href="https://gitcode.com/SUI517/xtRqHelper/blob/master/readme/guide.md"
              >🚀售后服务指南</a
            >
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      isMenuOpen: false,
      currentSlide: 0,
      autoPlayTimer: null
    };
  },
  
  // 页面标题和meta标签SEO优化
  mounted() {
    this.updatePageMeta();
    // 初始化 Intersection Observer
    this.initObservers();
    
    // FAQ 点击事件
    this.initFAQ();
    
    // 启动轮播图自动播放
    this.startAutoPlay();
  },
  
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    // 清除轮播图自动播放定时器
    this.stopAutoPlay();
  },
  methods: {
    updatePageMeta() {
      // 根据当前页面状态动态更新meta信息
      const metas = {
        title: '1900节拍器 - 专业电子节拍器 | 1900媒体助手 - 媒体资源下载工具',
        description: '1900节拍器 - 专业电子节拍器应用，精准节拍，丰富音效，人声喊拍功能。1900媒体助手 - 专业的微信小程序、抖音、B站等平台媒体资源下载工具。安全可靠，本地代理技术，保护隐私。',
        keywords: '1900节拍器, 电子节拍器, 音乐节拍器, 精准节拍, 人声喊拍, 1900媒体助手, 微信小程序下载, 抖音视频下载, B站视频下载, 视频下载工具, 图片下载工具, 网络数据抓取, 媒体资源下载, 客户端数据获取, 本地代理技术, 安全下载'
      };
      
      // 更新标题
      document.title = metas.title;
      
      // 更新描述
      const descTag = document.querySelector('meta[name="description"]');
      if (descTag) {
        descTag.setAttribute('content', metas.description);
      }
      
      // 更新关键词
      const keywordsTag = document.querySelector('meta[name="keywords"]');
      if (keywordsTag) {
        keywordsTag.setAttribute('content', metas.keywords);
      }
    },
 
    // 页面标题和meta标签SEO优化

    
  
    initObservers() {
      const cardObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("show");

              // 列表项动画
              const items = entry.target.querySelectorAll(".feature-content li");
              items.forEach((item, i) => {
                item.style.setProperty("--i", i);
                setTimeout(() => {
                  item.classList.add("show");
                }, i * 300);
              });

              cardObserver.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.2,
          rootMargin: "0px 0px -50px 0px",
        }
      );

      document.querySelectorAll(".feature-card").forEach((card) => {
        cardObserver.observe(card);
      });

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("show");
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.2,
          rootMargin: "0px 0px 0px 0px",
        }
      );

      document.querySelectorAll(".feature-card, .step, .download-card, .mini-product-card").forEach((card, i) => {
        card.style.setProperty("--i", i);
        observer.observe(card);
      });
    },
    
    initFAQ() {
      const faqQuestions = document.querySelectorAll('.faq-question');
      faqQuestions.forEach(question => {
        question.addEventListener('click', () => {
          const faqItem = question.parentElement;
          faqItem.classList.toggle('active');
          
          const toggle = question.querySelector('.faq-toggle');
          toggle.textContent = faqItem.classList.contains('active') ? '-' : '+';
        });
      });
      
      // 展开更多问题按钮
      const loadMoreBtn = document.getElementById('load-more-faq');
      if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', () => {
          // 这里可以添加加载更多FAQ的逻辑
          // 目前我们只是隐藏按钮并显示提示信息
          loadMoreBtn.style.display = 'none';
          
          // 创建提示信息
          const info = document.createElement('p');
          info.textContent = '没有更多问题了';
          info.style.textAlign = 'center';
          info.style.color = '#6c757d';
          info.style.marginTop = '20px';
          
          loadMoreBtn.parentElement.appendChild(info);
        });
      }
    },
    
    downfile() {
      const url = "./exe/rqhelper1900_setup.exe";
      const link = document.createElement("a");
      link.href = url;
      link.download = url.split("/").pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    downloadMac() {
    
      //实际项目中这里应该是真实的下载链接
      const url = "./exe/rqhelper1900.dmg";
      this.createDownloadLink(url);
    },
    downloadIOS() {
      // 跳转到App Store
      alert("即将跳转到App Store...");
      // 实际项目中这里应该是App Store链接
      // window.open("https://apps.apple.com/app/octopus-mini/idxxxxxx", "_blank");
    },
    downloadAndroid() {
    
      const url = "./apk/xqhelper1900.apk";
      this.createDownloadLink(url);
    },
    downloadMetronome() {
      // 1900节拍器Android版本下载
 
      const url = "./apk/metronome1900.apk";
      this.createDownloadLink(url);
    },
    downloadWindows() {
      // 模拟Windows Mini版本下载
      alert("1900媒体助手 Mini for Windows 正在准备下载...");
      // 实际项目中这里应该是真实的下载链接
      // const url = "./exe/OctopusMini-Windows.exe";
      // this.createDownloadLink(url);
    },
    createDownloadLink(url) {
      const link = document.createElement("a");
      link.href = url;
      link.download = url.split("/").pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    handleScroll() {},
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
    
    // 轮播图方法
    prevSlide() {
      this.currentSlide = (this.currentSlide - 1 + 7) % 7;
      this.updateCarousel();
      this.restartAutoPlay();
    },
    
    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % 7;
      this.updateCarousel();
      this.restartAutoPlay();
    },
    
    goToSlide(index) {
      this.currentSlide = index;
      this.updateCarousel();
      this.restartAutoPlay();
    },
    
    updateCarousel() {
      const carousel = this.$refs.carousel;
      if (carousel) {
        carousel.style.transform = `translateX(-${this.currentSlide * 100}%)`;
      }
    },
    
    // 自动播放方法
    startAutoPlay() {
      this.autoPlayTimer = setInterval(() => {
        this.nextSlide();
      }, 3000); // 每3秒自动切换一次
    },
    
    stopAutoPlay() {
      if (this.autoPlayTimer) {
        clearInterval(this.autoPlayTimer);
        this.autoPlayTimer = null;
      }
    },
    
    restartAutoPlay() {
      this.stopAutoPlay();
      this.startAutoPlay();
    }
  },
};
</script>

<style scoped>
body {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI",
    "PingFang SC", "Microsoft YaHei", sans-serif;
  line-height: 1.6;
  color: #212529;
  overflow-x: hidden;
  margin: 0;
  padding: 0;
  background-color: #f8f9fa;
  scroll-behavior: smooth;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* 导航栏 */
.navbar {
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  padding: 5px 0;
  position: sticky;
  top: 0;
  z-index: 100;
  transition: all 0.3s ease;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 700;
  font-size: 1.4rem;
  color: #01030f;
  animation: fadeInDown 0.8s ease;
}

.logo img {
  height: 48px;
  width: 48px;
  object-fit: contain;
  animation: pulse 2s infinite;
}

.nav-menu {
  display: flex;
  gap: 35px;
  animation: fadeInDown 0.8s ease;
}

.nav-menu a {
  text-decoration: none;
  color: #212529;
  font-weight: 500;
  font-size: 1.05rem;
  transition: all 0.3s ease;
  position: relative;
  padding: 5px 0;
}

.nav-menu a:after {
  content: "";
  position: absolute;
  width: 0;
  height: 2px;
  bottom: 0;
  left: 0;
  background-color: #4361ee;
  transition: all 0.3s ease;
}

.nav-menu a:hover:after {
  width: 100%;
}

.nav-menu a:hover {
  color: #4361ee;
}

.hamburger {
  display: none;
  flex-direction: column;
  cursor: pointer;
  z-index: 101;
}

.hamburger span {
  width: 28px;
  height: 3px;
  background-color: #212529;
  margin: 4px 0;
  transition: 0.3s;
  border-radius: 2px;
}

/* 英雄区域 */
.vbg {
  height: 600px;
  width: 100%;
  padding: 75px 0;
  background: linear-gradient(135deg, #0f2027, #203a43, #2c5364);
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.blurred-background {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0.3;
  top: 0;
  left: 0;
  object-fit: cover;
  z-index: 1;
}

.hero {
  color: white;
  text-align: center;
  z-index: 3;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  animation: fadeIn 1s ease;
}

.hero-title {
  font-size: 3rem;
  margin-bottom: 20px;
  font-weight: 800;
  letter-spacing: -0.5px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  animation: fadeInUp 1s ease;
}

.subtitle {
  font-size: 1.3rem;
  margin-bottom: 35px;
  max-width: 700px;
  font-weight: 400;
  opacity: 0.9;
  animation: fadeInUp 1s ease 0.2s both;
}

.cta-button {
  background: linear-gradient(90deg, #4361ee, #3f37c9);
  color: white;
  border: none;
  margin: 25px 0;
  padding: 15px 45px;
  border-radius: 50px;
  font-size: 1.2rem;
  font-weight: 600;
  box-shadow: 0 4px 15px rgba(67, 97, 238, 0.3);
  transition: all 0.3s ease;
  cursor: pointer;
  letter-spacing: 0.5px;
  animation: fadeInUp 1s ease 0.4s both;
}

.cta-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(67, 97, 238, 0.4);
  background: linear-gradient(90deg, #3f37c9, #4361ee);
}
.cta-button.primary {
  transform: translateY(-3px);
  box-shadow: 0 8px 5px rgba(67, 97, 238, 0.4);
  background: rgba(255, 255, 255, 1);
  margin: 10px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  color: rgba(67, 97, 238, 1);
}

.cta-button.secondary {
  margin: 10px;
  background: #fff;
  border: 2px solid #4361ee;
  box-shadow: 0 8px 5px rgba(67, 97, 238, 0.4);
  color: #4361ee;
}

.cta-button.secondary:hover ,cta-button.primary:hover{
  background: linear-gradient(90deg, #4361ee, #3f37c9);
  color: white;
  border-color: transparent;
  border: 2px solid #4361ee;
}

.supported-platforms {
  font-size: 1rem;
  opacity: 0.8;
  font-weight: 400;
  animation: fadeInUp 1s ease 0.6s both;
}

/* 功能区域 */
.features-section {
  margin: 100px 0;
  padding: 20px 0;
  position: relative;
  z-index: 2;
  scroll-margin-top: 80px; /* 用于现代浏览器的锚点偏移 */
}

/* 为不支持scroll-margin-top的旧浏览器提供兼容方案 */
@supports not (scroll-margin-top: 80px) {
  .features-section:before {
    content: "";
    display: block;
    height: 80px;
    margin-top: -80px;
    visibility: hidden;
    pointer-events: none;
  }
}

/* 其他锚点目标也需要同样的处理 */
#resource-download,
#security {
  scroll-margin-top: 80px;
}

.step-icon {
  width: 80px;
  height: 80px;

  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 25px;
  box-shadow: 0 4px 10px rgba(67, 97, 238, 0.3);
  padding: 10px;
}

.step-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

@supports not (scroll-margin-top: 80px) {
  #resource-download:before,
  #security:before {
    content: "";
    display: block;
    height: 80px;
    margin-top: -80px;
    visibility: hidden;
    pointer-events: none;
  }
}

/* 为锚点目标添加偏移量，避免被固定导航栏遮挡 */
.features-section:before {
  content: "";
  display: block;
  height: 80px; /* 导航栏高度 */
  margin-top: -80px;
  visibility: hidden;
  pointer-events: none;
}

/* 为1900媒体助手 Mini产品系列添加锚点偏移 */
.mini-products-section {
  scroll-margin-top: 80px;
}

@supports not (scroll-margin-top: 80px) {
  .mini-products-section:before {
    content: "";
    display: block;
    height: 80px;
    margin-top: -80px;
    visibility: hidden;
    pointer-events: none;
  }
}

.section-title {
  text-align: center;
  margin-bottom: 60px;
  font-size: 2.5rem;
  font-weight: 700;
  color: #212529;
  position: relative;
  animation: fadeInUp 0.8s ease;
}

.section-title:after {
  content: "";
  position: absolute;
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #4361ee, #f72585);
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 2px;
}

.features-grid {
  display: flex;
  align-items: center;
  flex-direction: row;
  border-radius: 12px;
  flex-wrap: wrap;
  transform: translateY(40px);
  transition: all 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  transition-delay: calc(0.15s * var(--i));
  justify-content: center;
  background: #ffffff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 50px;
  /* 移除 overflow: hidden 避免内容被裁剪 */
  opacity: 1; /* 默认显示 */
  animation: fadeInUp 0.8s ease forwards;
  position: relative;
  z-index: 1;
}

.features-grid.reverse {
  flex-direction: row-reverse;
}

.feature-content {
  display: flex;
  padding: 50px;
  flex-direction: column;
  flex: 1;
  min-width: 300px;
}

.feature-card {
  opacity: 0; /* 初始状态隐藏，用于动画效果 */
  flex: 1;
  transform: translateY(40px);
  transition: all 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  transition-delay: calc(0.15s * var(--i));
}

.feature-card.show {
  opacity: 1;
  transform: translateY(0) scale(1.02);
  transition: all 0.3s ease;
}

.vbg2 {
  flex: 1;
  justify-content: center;
  min-width: 300px;
  height: 350px;
  object-fit: cover;
}

.feature-content h3 {
  margin-bottom: 25px;
  color: #4361ee;
  font-size: 1.8rem;
  font-weight: 700;
}

.feature-content ul {
  list-style: inside;
  padding: 0;
}

.feature-content li {
  opacity: 0; /* 初始状态隐藏，用于动画效果 */
  transform: translateY(20px);
  transition: all 0.5s ease;
  transition-delay: calc(0.1s * var(--i));
  font-size: 1.1rem;
  font-weight: 500;
  margin-bottom: 15px;
  padding-left: 30px;
  position: relative;
  color: #6c757d;
}

.feature-content li.show {
  opacity: 1;
  transform: translateY(0);
}

/* 1900媒体助手Mini产品系列 */
.mini-products-section {
  padding: 100px 0;
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  text-align: center;
}

.mini-products-section .section-title:after {
  background: linear-gradient(90deg, #4361ee, #4cc9f0);
}

.section-subtitle {
  font-size: 1.2rem;
  color: #6c757d;

  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.section-subtitle.warning {
  color: #eac233;
  font-size: 1.3rem;
  margin-bottom: 60px;
  font-weight: 800;
}

.mini-products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  max-width: 1200px;

  margin: 0 auto;
}

.mini-product-card {
  background: white;
  padding: 40px 30px;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  opacity: 0;
  transform: translateY(30px);
}

.mini-product-card.show {
  opacity: 1;
  transform: translateY(0);
  transition-delay: calc(0.1s * var(--i));
}

.mini-product-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.mini-product-card:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, #4361ee, #4cc9f0);
}

.product-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  border-radius: 50%;
  padding: 15px;
}

.product-icon img {
  width: 50px;
  height: 50px;
  object-fit: contain;
}

.mini-product-card h3 {
  font-size: 1.4rem;
  margin-bottom: 15px;
  color: #212529;
  font-weight: 600;
}

.mini-product-card p {
  color: #6c757d;
  margin-bottom: 25px;
  line-height: 1.6;
  font-size: 1rem;
}

.product-features {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
  margin-bottom: 30px;
}

.feature-tag {
  background: linear-gradient(135deg, #4361ee, #4895ef);
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
}

.mini-download-btn {
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(67, 97, 238, 0.3);
}

.mini-download-btn.windows,
.windows {
  background: linear-gradient(135deg, #efe150, #ffa500);
}
.mini-download-btn.Android,
.Android {
  background: linear-gradient(135deg, #16fb0a, #04870c);
}
.mini-download-btn.iPhone,
.iPhone {
  background: linear-gradient(135deg, #e05158, #e40830);
}
.mini-download-btn.macOS,
.macOS {
  background: linear-gradient(135deg, #1831ef, #4895ef);
}

.mini-download-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(67, 97, 238, 0.4);
}

/* 工作原理 */
.how-it-works-section {
  background-color: #ffffff;
  padding: 100px 0;
  text-align: center;
}

.how-it-works-section .section-title:after {
  background: linear-gradient(90deg, #f72585, #4cc9f0);
}

.steps {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 30px;
}

.step {
  flex: 1;
  min-width: 220px;
  background: #ffffff;
  padding: 40px 30px;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  opacity: 0;
  transform: translateY(30px);
}

.step.show {
  opacity: 1;
  transform: translateY(0);
  transition-delay: calc(0.1s * var(--i));
}

.step:hover {
  transform: translateY(-10px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.step:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, #4361ee, #f72585);
}

.step h3 {
  margin-bottom: 20px;
  color: #212529;
  font-size: 1.4rem;
  font-weight: 600;
}

.step p {
  color: #6c757d;
  font-size: 1.05rem;
  line-height: 1.7;
}

/* 下载区域 */
.download-section {
  background: linear-gradient(135deg, #4361ee, #3a0ca3);
  padding: 100px 0;
  text-align: center;
  color: white;
}

.download-section .section-title:after {
  background: linear-gradient(90deg, #4cc9f0, #4895ef);
}

.download-section h2 {
  font-size: 2.5rem;
  margin-bottom: 25px;
  font-weight: 700;
}

.download-description {
  font-size: 1.2rem;
  max-width: 700px;
  margin: 0 auto 50px;
  font-weight: 300;
  opacity: 0.9;
}

.download-options {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-top: 50px;
  flex-wrap: wrap;
}

.download-card {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  padding: 40px 30px;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  position: relative;
  min-width: 280px;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.18);
  opacity: 0;
  transform: translateY(30px);
}

.download-card.show {
  opacity: 1;
  transform: translateY(0);
  transition-delay: calc(0.1s * var(--i));
}

.download-card:hover {
  transform: translateY(-10px);
  background: rgba(255, 255, 255, 0.15);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
}

.download-card img {
  height: 70px;
  margin-bottom: 20px;
}

/* 修改SVG图标颜色为白色 */
.download-card img[src$=".svg"] {
  filter: brightness(0) invert(1);
}

.download-card h3 {
  margin-bottom: 15px;
  font-size: 1.5rem;
  font-weight: 600;
}

.download-card p {
  margin-bottom: 25px;
  font-size: 1rem;
  opacity: 0.8;
}

.download-btn {
  background: white;
  color: #4361ee;
  border: none;
  color: #3a0ca3;
  padding: 12px 35px;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 600;
  font-size: 1.05rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.download-btn:hover:not(.disabled) {
  background: linear-gradient(90deg, #f72585, #b5179e);
  color: white;
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}

.download-btn.disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.coming-soon-badge {
  position: absolute;
  top: -12px;
  right: -12px;
  background: linear-gradient(90deg, #ffaa00, #ff0000);
  color: white;
  padding: 8px 15px;
  border-radius: 30px;
  font-size: 0.85rem;
  font-weight: bold;
  box-shadow: 0 4px 10px rgba(247, 37, 133, 0.3);
}

/* FAQ 部分 */
.faq-section {
  padding: 100px 0;
  background-color: #f8f9fa;
}
.white {
  color: #fff;
}
.faq-section .section-title:after {
  background: linear-gradient(90deg, #0370ff, #4895ef);
}

.faq-container {
  max-width: 900px;
  margin: 0 auto;
}

.faq-item {
  background: #ffffff;
  border-radius: 12px;
  margin-bottom: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
}

.faq-item:hover {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
}

.faq-question {
  padding: 25px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: white;
}

.faq-question:hover {
  background-color: #f8f9fa;
}

.faq-question h3 {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 600;
  color: #212529;
}

.faq-toggle {
  font-size: 1.8rem;
  font-weight: 300;
  color: #4361ee;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.faq-answer {
  padding: 0 30px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.4s ease, padding 0.4s ease, background 0.3s ease;
  background: #f8f9fa;
}

.faq-item.active .faq-answer {
  padding: 25px 30px;
  max-height: 500px;
}

.faq-answer p {
  color: #6c757d;
  line-height: 1.7;
  font-size: 1.05rem;
}

/* 页脚 */
.footer {
  background: #0f172a;
  color: #cbd5e1;
  padding: 70px 0 30px;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  margin-bottom: 50px;
  gap: 40px;
}

.footer-section h4 {
  margin-bottom: 25px;
  font-size: 1.3rem;
  color: white;
  font-weight: 600;
  position: relative;
  padding-bottom: 10px;
}
.footer-section.secondary h4 {
  color: #55aaff;
}
.footer-section.secondary a {
  color: #ebeb00;
}
.footer-section h4:after {
  content: "";
  position: absolute;
  width: 40px;
  height: 3px;
  background: #4361ee;
  bottom: 0;
  left: 0;
  border-radius: 2px;
}

.footer-section a {
  color: #94a3b8;
  margin-bottom: 12px;
  text-decoration: none;
  transition: all 0.3s ease;
  display: block;
  font-size: 1.05rem;
  line-height: 1.6;
}

.footer-section a:hover {
  color: #4361ee;
  transform: translateX(5px);
}

.copyright {
  text-align: center;
  color: #94a3b8;
  font-size: 1rem;
  padding-top: 30px;
  border-top: 1px solid #1e293b;
  margin-top: 20px;
}

.copyright a {
  text-decoration: none;
  transition: all 0.3s ease;
  color: #94a3b8;
}

.copyright a:hover {
  color: #4361ee;
}

/* 动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

/* 响应式设计 */
@media screen and (max-width: 1200px) {
  .container {
    padding: 0 25px;
  }

  .hero-title {
    font-size: 2.8rem;
  }

  .subtitle {
    font-size: 1.2rem;
  }

  .features-grid {
    flex-direction: column;
  }

  .features-grid.reverse {
    flex-direction: column;
  }

  .vbg2 {
    width: 100%;
    height: 350px;
  }

  .steps {
    flex-direction: column;
  }

  .download-options {
    flex-direction: column;
    align-items: center;
  }

  .feature-content {
    padding: 40px;
  }
}

@media screen and (max-width: 992px) {
  .container {
    padding: 0 20px;
  }

  .hero-title {
    font-size: 2.5rem;
  }

  .subtitle {
    font-size: 1.1rem;
  }

  .vbg2 {
    height: 300px;
  }

  .step {
    min-width: 200px;
  }

  .feature-content {
    padding: 35px;
  }
}
.logo span {
  color: #020c1a;
}
@media screen and (max-width: 768px) {
  .navbar {
    padding: 15px;
  }

  .logo {
    font-size: 1.3rem;
  }

  .logo img {
    height: 32px;
  }

  .nav-menu {
    position: fixed;
    left: -100%;
    top: 0;
    flex-direction: column;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    width: 100%;
    height: 100vh;
    text-align: center;
    transition: 0.4s;
    box-shadow: 0 10px 27px rgba(0, 0, 0, 0.05);
    padding: 100px 0;
    z-index: 100;
  }

  .nav-menu.active {
    left: 0;
    box-shadow: 0 10px 27px rgba(0, 0, 0, 0.05);
    background-color: rgba(255, 255, 255, 0.99);
  }

  .nav-menu a {
    padding: 20px;
    display: block;
    font-size: 1.2rem;
  }

  .hamburger {
    display: flex;
  }

  .hamburger.active span:nth-child(2) {
    opacity: 0;
  }

  .hamburger.active span:nth-child(1) {
    transform: translateY(11px) rotate(45deg);
  }

  .hamburger.active span:nth-child(3) {
    transform: translateY(-11px) rotate(-45deg);
  }

  .vbg {
    height: 500px;
  }

  .hero-title {
    font-size: 2.2rem;
  }

  .subtitle {
    font-size: 1.05rem;
  }

  .feature-content {
    padding: 30px;
  }

  .step {
    padding: 30px 20px;
  }

  .download-card {
    padding: 30px 20px;
    min-width: 250px;
  }

  .faq-question {
    padding: 20px;
  }

  .faq-item.active .faq-answer {
    padding: 20px;
  }

  .section-title {
    font-size: 2.2rem;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 30px;
  }
}

@media screen and (max-width: 576px) {
  .container {
    padding: 0 15px;
  }

  .hero-title {
    font-size: 2rem;
  }

  .vbg {
    height: 450px;
  }

  .section-title {
    font-size: 2rem;
  }

  .feature-content {
    padding: 25px 20px;
  }

  .step {
    padding: 25px 15px;
    min-width: 100%;
  }

  .download-card {
    padding: 25px 15px;
    min-width: 100%;
  }

  .download-description {
    font-size: 1rem;
  }

  .faq-question {
    padding: 15px;
  }

  .faq-item.active .faq-answer {
    padding: 15px;
  }

  .nav-menu a {
    padding: 15px;
    font-size: 1.1rem;
  }
}

@media screen and (max-width: 480px) {
  .hero-title {
    font-size: 1.8rem;
  }

  .subtitle {
    font-size: 1rem;
  }

  .vbg {
    height: 400px;
  }

  .section-title {
    font-size: 1.8rem;
  }

  .feature-content {
    padding: 20px 15px;
  }

  .feature-content h3 {
    font-size: 1.5rem;
  }

  .feature-content li {
    font-size: 1rem;
    padding-left: 25px;
  }

  .step {
    padding: 20px 15px;
  }

  .step h3 {
    font-size: 1.2rem;
  }

  .step p {
    font-size: 0.95rem;
  }

  .download-card {
    padding: 20px 15px;
  }

  .download-card h3 {
    font-size: 1.3rem;
  }

  .download-description {
    font-size: 0.95rem;
  }

  .faq-question h3 {
    font-size: 1.1rem;
  }

  .faq-answer p {
    font-size: 0.95rem;
  }
}

/* 1900节拍器APP页面样式 */
.metronome-app-section {
  padding: 100px 0;
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  text-align: center;
}

.metronome-screenshots {
  margin: 60px 0;
}

/* 轮播图样式 */
.carousel-container {
  position: relative;
  max-width: 80%;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(67, 97, 238, 0.3);
  background: white;
  padding: 20px;
  overflow: hidden;
  animation: breathe 3s ease-in-out infinite;
}

.carousel-container::before {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(
    circle,
    rgba(67, 97, 238, 0.2) 0%,
    transparent 50%
  );
  animation: rotateGlow 5s linear infinite;
  z-index: 0;
  pointer-events: none;
}

/* 移除背景纹理效果 */
.carousel-container::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  pointer-events: none;
}

.carousel-container > * {
  position: relative;
  z-index: 1;
}

/* 4/4拍呼吸动画 - 强-弱-次强-弱，仅阴影颜色变化 */
@keyframes breathe {
  0% {
    /* 第1拍：强 - 红色阴影 */
    background: white;
    box-shadow: 0 30px 80px rgba(255, 77, 77, 0.8);
    filter: brightness(1.2);
  }
  25% {
    /* 第2拍：弱 - 白色阴影 */
    background: white;
    box-shadow: 0 15px 40px rgba(255, 255, 255, 0.3);
    filter: brightness(1.05);
  }
  50% {
    /* 第3拍：次强 - 黄色阴影 */
    background: white;
    box-shadow: 0 25px 60px rgba(255, 215, 0, 0.6);
    filter: brightness(1.15);
  }
  75% {
    /* 第4拍：弱 - 绿色阴影 */
    background: white;
    box-shadow: 0 10px 30px rgba(76, 175, 80, 0.2);
    filter: brightness(1);
  }
  100% {
    /* 回到第1拍：强 - 红色阴影 */
    background: white;
    box-shadow: 0 30px 80px rgba(255, 77, 77, 0.8);
    filter: brightness(1.2);
  }
}

/* 旋转光晕动画 */
@keyframes rotateGlow {
  0% {
    transform: rotate(0deg);
    opacity: 0.1;
  }
  50% {
    opacity: 0.2;
  }
  100% {
    transform: rotate(360deg);
    opacity: 0.3;
  }
}

/* 土泡泡效果样式 */
.bubbles {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;
}

.bubble-item {
  position: absolute;
  bottom: -50px;
  border-radius: 50%;
  animation: bubbleRise 6s ease-in-out infinite;
  animation-delay: calc(var(--i) * 0.4s);
  opacity: 0;
  pointer-events: none;
}

/* 为不同的泡泡设置随机大小、位置和丰富的颜色 */
.bubble-item:nth-child(1n) {
  background: radial-gradient(
    135deg,
    rgba(67, 97, 238, 0.6) 0%,
    rgba(67, 97, 238, 0.2) 70%,
    transparent 100%
  );
  width: calc(20px + var(--i) * 2px);
  height: calc(20px + var(--i) * 2px);
  left: calc(10% + var(--i) * 6%);
  animation-duration: calc(4s + var(--i) * 0.3s);
}

.bubble-item:nth-child(2n) {
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.3) 0%,
    rgba(247, 37, 133, 0.2) 70%,
    transparent 100%
  );
  width: calc(15px + var(--i) * 1.5px);
  height: calc(15px + var(--i) * 1.5px);
  left: calc(5% + var(--i) * 8%);
  animation-duration: calc(5s + var(--i) * 0.2s);
}

.bubble-item:nth-child(3n) {
  background: radial-gradient(
    circle,
    rgba(10, 215, 255, 0.6) 0%,
    rgba(10, 215, 255, 0.2) 70%,
    transparent 100%
  );
  width: calc(18px + var(--i) * 1.8px);
  height: calc(18px + var(--i) * 1.8px);
  left: calc(15% + var(--i) * 7%);
  animation-duration: calc(4.5s + var(--i) * 0.25s);
}

.bubble-item:nth-child(4n) {
  background: radial-gradient(
    circle,
    rgba(48, 209, 88, 0.6) 0%,
    rgba(48, 209, 88, 0.2) 70%,
    transparent 100%
  );
  width: calc(22px + var(--i) * 2.2px);
  height: calc(22px + var(--i) * 2.2px);
  left: calc(8% + var(--i) * 9%);
  animation-duration: calc(5.5s + var(--i) * 0.15s);
}

.bubble-item:nth-child(5n) {
  background: radial-gradient(
    circle,
    rgba(255, 159, 10, 0.6) 0%,
    rgba(255, 159, 10, 0.2) 70%,
    transparent 100%
  );
  width: calc(16px + var(--i) * 1.6px);
  height: calc(16px + var(--i) * 1.6px);
  left: calc(12% + var(--i) * 5%);
  animation-duration: calc(6s + var(--i) * 0.1s);
}

/* 泡泡上升动画 */
@keyframes bubbleRise {
  0% {
    transform: translateY(0) scale(0);
    opacity: 0.8;
  }
  50% {
    opacity: 1;
    transform: translateY(-200px) scale(1.2);
  }
  100% {
    transform: translateY(-400px) scale(0.5);
    opacity: 0;
  }
}

.carousel {
  display: flex;
  transition: transform 0.5s ease-in-out;
  width: 100%;
  height: 400px;
}

.carousel-slide {
  flex: 0 0 100%;
  height: 100%;

  justify-content: center;
  align-items: flex-end;
  overflow: hidden;
}

.carousel-image {
  max-width: 100%;
  height: 90%; /* 100% / 0.6 ≈ 167%，这样显示下半部分60% */
  object-fit: cover;
  object-position: center;
  border-radius: 30px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.carousel-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(67, 97, 238, 0.8);
  color: white;
  border: none;
  padding: 15px 20px;
  font-size: 1.5rem;
  cursor: pointer;
  border-radius: 50%;
  transition: all 0.3s ease;
  z-index: 10;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.carousel-btn:hover {
  background: rgba(67, 97, 238, 1);
  transform: translateY(-50%) scale(1.1);
  box-shadow: 0 6px 20px rgba(67, 97, 238, 0.3);
}

.carousel-btn.prev {
  left: 30px;
}

.carousel-btn.next {
  right: 30px;
}

.carousel-indicators {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 12px;
  z-index: 20;
  background: rgba(255, 255, 255, 0.8);
  padding: 8px 16px;
  border-radius: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgba(67, 97, 238, 0.5);
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.indicator.active {
  background: rgba(67, 97, 238, 1);
  transform: scale(1.4);
  width: 12px;
  height: 12px;
  border-color: white;
  box-shadow: 0 0 0 2px rgba(67, 97, 238, 0.3);
}

.metronome-features {
  margin: 80px 0;
}

.features-title {
  font-size: 2rem;
  margin-bottom: 50px;
  color: #212529;
  font-weight: 700;
}

.features-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 10px;
  max-width: 1200px;
  margin: 0 auto;
}

.feature-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 20px;
  background: white;
  padding: 20px;
  border-radius: 16px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  transform: translateY(20px);
  opacity: 0;
  animation: fadeInUp 0.8s ease forwards;
  animation-delay: calc(0.1s * var(--i));
}

.feature-item:hover {
  transform: translateY(-10px) scale(1.02);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.feature-icon {
  font-size: 3rem;
  margin-top: 20px;
  animation: pulse 2s infinite;
}

.feature-content {
  width: 100%;
}

.feature-content h4 {
  font-size: 1.4rem;

  color: #4361ee;
  font-weight: 600;
}

.feature-content p {
  color: #6c757d;
  line-height: 1.6;
  font-size: 1.05rem;
  margin: 0;
}

.metronome-download {
  margin-top: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  background: linear-gradient(
      135deg,
      rgba(67, 97, 238, 0.9),
      rgba(63, 55, 201, 0.9)
    ),
    url("@/assets/ic_launcher_round.png");
  background-size: cover, 100px 100px;
  background-position: center, center;
  background-repeat: no-repeat, repeat;
  background-blend-mode: overlay;
  padding: 50px;
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(67, 97, 238, 0.5);
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  color: white;
  position: relative;
  overflow: hidden;
}

.metronome-download::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(67, 97, 238, 0.8),
    rgba(63, 55, 201, 0.8)
  );
  z-index: 1;
  border-radius: 20px;
}

/* 水泡动画 */
.metronome-download::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(
    circle at var(--x) var(--y),
    rgba(255, 255, 255, 0.3) 0%,
    transparent 70%
  );
  background-size: 200px 200px;
  background-repeat: no-repeat;
  animation: bubbleAnimation 8s ease-in-out infinite;
  z-index: 1;
  pointer-events: none;
}

/* 多个水泡效果 */
.metronome-download .bubble {
  position: absolute;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.2) 0%,
    transparent 70%
  );
  border-radius: 50%;
  animation: bubbleFloat 6s ease-in-out infinite;
  z-index: 1;
  pointer-events: none;
}

.metronome-download .bubble:nth-child(1) {
  width: 80px;
  height: 80px;
  left: 10%;
  top: 20%;
  animation-delay: 0s;
}

.metronome-download .bubble:nth-child(2) {
  width: 120px;
  height: 120px;
  right: 15%;
  top: 30%;
  animation-delay: 2s;
}

.metronome-download .bubble:nth-child(3) {
  width: 60px;
  height: 60px;
  left: 20%;
  bottom: 20%;
  animation-delay: 4s;
}

.metronome-download .bubble:nth-child(4) {
  width: 100px;
  height: 100px;
  right: 25%;
  bottom: 15%;
  animation-delay: 1s;
}

/* 水泡浮动动画 */
@keyframes bubbleFloat {
  0%,
  100% {
    transform: translateY(0) scale(1);
    opacity: 0.3;
  }
  50% {
    transform: translateY(-30px) scale(1.1);
    opacity: 0.6;
  }
}

/* 背景水泡扩散动画 */
@keyframes bubbleAnimation {
  0% {
    --x: 10%;
    --y: 10%;
    transform: scale(0.5);
    opacity: 0;
  }
  25% {
    --x: 90%;
    --y: 20%;
    transform: scale(1.2);
    opacity: 0.4;
  }
  50% {
    --x: 50%;
    --y: 80%;
    transform: scale(0.8);
    opacity: 0.3;
  }
  75% {
    --x: 15%;
    --y: 70%;
    transform: scale(1.1);
    opacity: 0.5;
  }
  100% {
    --x: 85%;
    --y: 90%;
    transform: scale(0.6);
    opacity: 0;
  }
}

.metronome-download > * {
  position: relative;
  z-index: 2;
}

.metronome-download .cta-button {
  margin: 0;
  background: white;
  color: #4361ee;
  border: 2px solid white;
  font-size: 1.2rem;
  padding: 15px 50px;
  transition: all 0.3s ease;
}

.metronome-download .cta-button:hover {
  background: transparent;
  color: white;
  transform: translateY(-3px) scale(1.05);
  box-shadow: 0 6px 20px rgba(255, 255, 255, 0.2);
}

.metronome-download .supported-platforms {
  color: rgba(255, 255, 255, 0.9);
  font-size: 1.1rem;
  margin: 0;
}

/* 响应式轮播图 */
@media (max-width: 768px) {
  .carousel-container {
    max-width: 100%;
    padding: 15px;
  }

  .carousel {
    height: 400px;
  }

  .carousel-btn {
    width: 40px;
    height: 40px;
    font-size: 1.2rem;
    padding: 12px 16px;
  }

  .carousel-btn.prev {
    left: 20px;
  }

  .carousel-btn.next {
    right: 20px;
  }

  .metronome-download {
    padding: 30px 20px;
  }

  .metronome-download .cta-button {
    font-size: 1.1rem;
    padding: 12px 40px;
  }
}

@media (max-width: 480px) {
  .carousel {
    height: 300px;
  }

  .carousel-btn {
    width: 35px;
    height: 35px;
    font-size: 1rem;
    padding: 10px 14px;
  }

  .carousel-btn.prev {
    left: 15px;
  }

  .carousel-btn.next {
    right: 15px;
  }

  .carousel-indicators {
    bottom: 15px;
  }

  .indicator {
    width: 10px;
    height: 10px;
  }

  .indicator.active {
    width: 12px;
    height: 12px;
  }
}

/* 添加锚点偏移样式 */
.features-section {
  margin: 100px 0;
  padding: 20px 0;
  position: relative;
  z-index: 2;
  scroll-margin-top: 80px; /* 用于现代浏览器的锚点偏移 */
}

/* 为不支持scroll-margin-top的旧浏览器提供兼容方案 */
@supports not (scroll-margin-top: 80px) {
  .features-section:before {
    content: "";
    display: block;
    height: 80px;
    margin-top: -80px;
    visibility: hidden;
    pointer-events: none;
  }
}

/* 其他锚点目标也需要同样的处理 */
#resource-download,
#security,
#high-quality-download,
#batch-download,
#wechat-miniprogram,
#douyin,
#kuaishou,
#weibo-zhihu {
  scroll-margin-top: 80px;
}

@supports not (scroll-margin-top: 80px) {
  #resource-download:before,
  #security:before,
  #high-quality-download:before,
  #batch-download:before,
  #wechat-miniprogram:before,
  #douyin:before,
  #kuaishou:before,
  #weibo-zhihu:before {
    content: "";
    display: block;
    height: 80px;
    margin-top: -80px;
    visibility: hidden;
    pointer-events: none;
  }
}
</style>